import {AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import * as L from 'leaflet';
import 'leaflet.markercluster';
import {GlobalDataService} from "../../../shared-services/global-data.service";
import {ScreensService} from "../../../theme/screens/screens.service";

@Component({
    selector: 'app-root-map',
    templateUrl: './root-map.component.html',
    styleUrls: ['./root-map.component.scss']
})
export class RootMapComponent implements OnInit, AfterViewInit, OnChanges {

    @Input()
    selectedSite: any;

    private markerList = [];
    private map = null;
    private icons = {
        "active": L.icon({
            iconUrl: 'assets/images/marker.png',
            iconSize: [35, 35],
            iconAnchor: [17.5, 17.5],
            popupAnchor: [-3, -76],
        }),
        "inactive": L.icon({
            iconUrl: 'assets/images/marker-inactive.png',
            iconSize: [35, 35],
            iconAnchor: [17.5, 17.5],
            popupAnchor: [-3, -76],
        })
    };
    private markers: any;

    constructor(private http: HttpClient, private globalService: GlobalDataService, private screenService: ScreensService) {
    }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.selectedSite.previousValue && changes.selectedSite.currentValue) {
            let marker = this.markerList.find((marker) => marker.id === changes.selectedSite.currentValue['id']);
            if (marker) {
                const newLatLng = new L.LatLng(changes.selectedSite.currentValue.latitude, changes.selectedSite.currentValue.longitude);
                marker.setLatLng(newLatLng);
                marker.getTooltip().setContent(this.setSiteText(changes.selectedSite.currentValue));
                this.map.flyTo(marker.getLatLng(), 13);
            } else {
                const newLatLng = new L.LatLng(changes.selectedSite.currentValue.latitude, changes.selectedSite.currentValue.longitude);
                this.addMarker(changes.selectedSite.currentValue);
                this.map.flyTo(newLatLng, 9);
            }

        }
    }


    ngAfterViewInit(): void {
        this.map = L.map('mapRoot', {
            minZoom: 2,
            attributionControl: false
        }).setView([39.840149, 22.954765], 6);
        L.tileLayer('https://tiles.wmflabs.org/osm-no-labels/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(this.map);
        let marker = L.marker([48.636591, 13.601378], {opacity: 0}); //opacity may be set to zero
        marker.bindTooltip("Europe", {permanent: true, className: "my-label", offset: [0, 0]});
        marker.addTo(this.map);
        this.http.get('assets/json/europe.geojson.json')
            .subscribe((geoData: any) => {
                L.geoJSON(geoData, {
                    style: function (feature) {
                        return {color: feature.properties.fill, weight: 1}
                    }
                }).addTo(this.map);
            });
        this.screenService.sites.subscribe((sites) => {
            if (this.markerList.length > 0) {
                this.markerList = [];
                this.map.removeLayer(this.markers);
            }
            this.createMarkers(sites);
        })
    }

    private createMarkers(sites) {
        this.markers = L.markerClusterGroup({maxClusterRadius: 30});
        sites.forEach((site) => {
            site['siteMonumentCount'] = 0;
            let iconSelect = site['active'] ? 'active' : 'inactive';
            const text = this.globalService.currentMobileLang === 'el' ? '(Δωρεάν Προβολή)' : '(Free preview)';
            if (site['id'] == 1) {
                const currentMarkerSite = L.marker([site["latitude"], site["longitude"]],
                    {icon: this.icons[iconSelect]})
                    .bindTooltip(this.setSiteText(site),
                        {
                            permanent: true,
                            direction: 'left',
                            offset: L.point(-6, 3),
                            className: "siteName"
                        })
                    .on('click', site['active'] ? function () {

                    } : function () {
                        return false;
                    });
                currentMarkerSite['id'] = site['id'];
                this.markerList.push(currentMarkerSite);
                this.markers.addLayer(currentMarkerSite);
            } else {
                this.addMarker(site);
            }
        });
        this.map.addLayer(this.markers);
    }

    private setSiteText(site) {
        const text = this.globalService.currentMobileLang === 'el' ? '(Δωρεάν Προβολή)' : '(Free preview)';
        return site['free'] ? this.globalService.getObjectTranslation(site['siteTranslations'], 'name') + '<br/><em>' + text + '</em>' : this.globalService.getObjectTranslation(site['siteTranslations'], 'name');
    }

    private addMarker(site) {
        let iconSelect = site['active'] ? 'active' : 'inactive';
        const currentMarkerSite = L.marker([site["latitude"], site["longitude"]], {icon: this.icons[iconSelect]})
            .bindTooltip(this.setSiteText(site),
                {
                    permanent: true,
                    direction: (site['id'] == 3) ? 'left' : 'right',
                    offset: L.point(6, 4),
                    className: "siteName"
                }).on('click', site['active'] ? function () {

            } : function () {
                return false;
            });
        currentMarkerSite['id'] = site['id'];
        this.markerList.push(currentMarkerSite);
        this.markers.addLayer(currentMarkerSite);
    }


}
